import api from './axiosInstance';

const triggerDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob instanceof Blob ? blob : new Blob([blob]));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const downloadExcel = async (filter = {}) => {
  const params = {};
  if (filter.departmentId) params.departmentId = filter.departmentId;
  if (filter.groupCode)    params.groupCode    = filter.groupCode;
  const blob = await api.get('/excel/download', { responseType: 'blob', params });
  let suffix = '';
  if (filter.groupCode)         suffix = `_${filter.groupCode}`;
  else if (filter.departmentName) suffix = `_${filter.departmentName.replace(/\s+/g, '_')}`;
  triggerDownload(blob, `Material_Price_List${suffix}.xlsx`);
};

export const downloadTemplate = async () => {
  const blob = await api.get('/excel/template', { responseType: 'blob' });
  triggerDownload(blob, 'epc_template.xlsx');
};

export const uploadExcel = async (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  // axiosInstance interceptor returns res.data directly
  return api.post('/excel/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
};

export const pollJob = (jobId) => api.get(`/excel/jobs/${jobId}`);

export const downloadMaterialMasterData = async (filter = {}) => {
  const params = {};
  if (filter.departmentId) params.departmentId = filter.departmentId;
  if (filter.groupCode)    params.groupCode    = filter.groupCode;
  const blob = await api.get('/excel/master-data', { responseType: 'blob', params });
  let suffix = '';
  if (filter.groupCode)         suffix = `_${filter.groupCode}`;
  else if (filter.departmentName) suffix = `_${filter.departmentName.replace(/\s+/g, '_')}`;
  triggerDownload(blob, `material_master_data${suffix}.xlsx`);
};
